import { forwardRef } from "react"
import { mergeClasses } from "@lib/css"

import type { IconProps } from "./types"

export const IconArrowRight = forwardRef<SVGSVGElement, IconProps>(
  function IconArrowRight(props, ref) {
    const { className, title, titleId, ...otherProps } = props
    const defaultClasses =
      "w-8 h-8 flex-shrink-0 transition-colors duration-150 ease-in focus:outline-none"
    const classes = mergeClasses(defaultClasses, className)

    return (
      <svg
        ref={ref}
        viewBox="0 0 32 32"
        fill="none"
        focusable="false"
        aria-hidden="true"
        tabIndex={-1}
        className={classes}
        aria-labelledby={titleId}
        {...otherProps}
      >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
          d="M11.1505 28.3999L21.7505 16.3999C21.8468 16.2889 21.8999 16.1469 21.8999 15.9999C21.8999 15.8529 21.8468 15.7109 21.7505 15.5999L11.1505 3.59991C11.0981 3.54058 11.0345 3.49219 10.9633 3.45754C10.8922 3.42289 10.8149 3.40266 10.7359 3.39801C10.6569 3.39336 10.5777 3.40439 10.503 3.43046C10.4283 3.45653 10.3594 3.49713 10.3005 3.54991C10.1829 3.65711 10.112 3.80596 10.1026 3.96475C10.0933 4.12353 10.1463 4.27968 10.2505 4.39991L20.5005 15.9999L10.2505 27.5999C10.1463 27.7201 10.0933 27.8763 10.1026 28.0351C10.112 28.1939 10.1829 28.3427 10.3005 28.4499C10.3594 28.5027 10.4283 28.5433 10.503 28.5694C10.5777 28.5954 10.6569 28.6065 10.7359 28.6018C10.8149 28.5972 10.8922 28.5769 10.9633 28.5423C11.0345 28.5076 11.0981 28.4592 11.1505 28.3999Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
